import { render } from "./FormBody.vue?vue&type=template&id=023dd837"
const script = {}

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"source/js/vue/components/sections/FormBody.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "023dd837"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('023dd837', __exports__)) {
    api.reload('023dd837', __exports__)
  }
  
  module.hot.accept("./FormBody.vue?vue&type=template&id=023dd837", () => {
    api.rerender('023dd837', render)
  })

}


export default __exports__